/**
 * Format decimal age (years) into a human-readable string.
 * API returns age as a decimal year (e.g., 0.1 for ~1 month, 40.5 for 40 years).
 */
export const formatAge = (age) => {
  if (age === null || age === undefined || isNaN(age)) return "";
  const num = Number(age);
  if (isNaN(num)) return "";
  if (num < 1 / 12) return "Infant";
  if (num < 1) {
    const months = Math.round(num * 12);
    return `${months} month${months !== 1 ? "s" : ""}`;
  }
  return `${Math.floor(num)} yrs`;
};

export const formatGenderShort = (gender = "") => {
  const normalized = String(gender).trim().toLowerCase();

  if (normalized === "male") return "M";
  if (normalized === "female") return "F";
  if (normalized === "other") return "O";
  return normalized ? normalized.charAt(0).toUpperCase() : "";
};

export const formatPatientAge = (ageByDob, gender) => {
  const age = Number(ageByDob);
  const ageText = Number.isFinite(age) ? formatAge(age).replace(" yrs", "") : "";
  const genderText = formatGenderShort(gender);

  if (ageText && genderText) return `${ageText} / ${genderText}`;
  return ageText || genderText || "";
};
